"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thePlaceTheme = void 0;
const default_1 = __importDefault(require("./default"));
exports.thePlaceTheme = Object.assign(Object.assign({}, default_1.default), { name: 'the-place', typography: Object.assign(Object.assign({}, default_1.default.typography), { display: {
            small: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1.625rem',
                lineHeight: '38px',
            },
            medium: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '2rem',
                lineHeight: '44px',
            },
            large: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '2.375rem',
                lineHeight: '56px',
            },
            x_large: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '2.625rem',
                lineHeight: '62px',
            },
        }, heading: {
            heading: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 500,
                fontSize: '1.625rem',
                lineHeight: 'normal',
            },
            subheading: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 500,
                fontSize: '1.25rem',
                lineHeight: 'normal',
            },
            small: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1.125rem',
                lineHeight: 'normal',
            },
        }, section: {
            bigTitle: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1.5rem',
                lineHeight: 'normal',
            },
            subtitle: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 500,
                fontSize: '1.125rem',
                lineHeight: '22px',
            },
            title: {
                fontFamily: default_1.default.fontFamily.title,
                fontWeight: 700,
                fontSize: '1.25rem',
                lineHeight: 'normal',
            },
        } }), colors: Object.assign(Object.assign({}, default_1.default.colors), { css: Object.assign(Object.assign({}, default_1.default.colors.css), { primary: 'invert(0%) sepia(96%) saturate(0%) hue-rotate(96deg) brightness(88%) contrast(104%)' }), main: {
            base: '#000000',
            tap: '#464650',
            hover: '#22222B',
            focus: 'rgba(0, 0, 0, 0.4)',
        }, borders: {
            default: '#000000',
            hover: '#000000',
        }, background: {
            primary: '#ffffff',
            secondary: '#000000',
        }, text: {
            body: '#000000',
            title: '#000000',
            alternate: {
                body: '#ffffff',
                title: '#ffffff',
            },
        }, accent: {
            base: '#000000',
        }, discount: {
            base: '#000000',
            savings: '#000000',
            premium: '#000000',
        } }), overrides: {
        price: {
            colors: {
                unavailable: {
                    primary: '#75757a',
                    secondary: '#a2a2a7',
                },
            },
        },
        dropdown: {
            borderColors: {
                default: '#000000',
                hover: '#000000',
                disabled: '#e1e1e4',
            },
        },
    } });
exports.default = exports.thePlaceTheme;
